import React from 'react'
import Link from 'gatsby-link'
import Signupform from '../components/signupform'
import {
  Divider,
  Segment,
  Container,
  List,
  Header,
  Grid,
  Button,
} from 'semantic-ui-react'

const Footer = () => (
  <Segment inverted vertical style={{ padding: '5em 0em', background: '#091621'

  }}>
    <Container>
      <Grid divided inverted stackable>
        <Grid.Row>
          <Grid.Column width={3}>
            <Header inverted as="h4" content="Find Tools" />
            <List link inverted>
            <List.Item href="/search/">Search</List.Item>
              <List.Item href="/categories/">Category</List.Item>
              <List.Item href="/growthlevers/">Growth Lever</List.Item>
              <List.Item href="/integrations/">Integration</List.Item>
              <List.Item href="/customers/">Customer</List.Item>
            </List>
          </Grid.Column>
          <Grid.Column width={3}>
            <Header inverted as="h4" content="About" />
            <List link inverted>
              <List.Item href="/about/">About FGT</List.Item>
              <List.Item href="/suggest/">Suggest a tool</List.Item>
              <List.Item href="/contact/">Contact</List.Item>
              <List.Item href="https://www.growthjobs.io" target="_blank">GrowthJobs.io</List.Item>
              <List.Item ></List.Item>
<List.Item>  <Button
              circular
              color="facebook"
              href="https://fb.me/findgrowthtools"
              target="_blank"
              icon="facebook"
              size='mini'
            />

            <Button
              circular
              color="twitter"
              href="https://twitter.com/FindGrowthTools"
              target="_blank"
              icon="twitter"
              size='mini'
            /></List.Item>


            </List>
          </Grid.Column>
         
          <Grid.Column width={7}>
            <Header as="h4" inverted>
              Newsletter
            </Header>
            <List.Item>
              <Signupform />
            </List.Item>
          </Grid.Column>
        </Grid.Row>
      </Grid>
    </Container>
  </Segment>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/footer.js